import BButton from 'components/common/BButton';
import ExperienceCard from 'components/Experience/ExperienceCard';
import VehicleCard from 'components/Vehicle/VehicleCard';
import useTranslation from 'next-translate/useTranslation';
import { FunctionComponent } from 'react';
import { ExperienceSummary } from 'types/experience/experience-summary.type';
import { VehicleSummary } from 'types/vehicle.type';

export interface VehicleListProps {
  vehicles: (VehicleSummary | ExperienceSummary)[];
  onPageChange: () => void;
  isThereMorePage: boolean;
  location?: string;
}

function isVehicle(
  vehicle: VehicleSummary | ExperienceSummary
): vehicle is VehicleSummary {
  return 'vehicleId' in vehicle;
}

const VehicleList: FunctionComponent<VehicleListProps> = ({
  vehicles,
  onPageChange,
  isThereMorePage,
  location,
}) => {
  const { t } = useTranslation('common');
  const content = vehicles || [];

  return (
    <>
      <div className="grid grid-cols-1 justify-items-center gap-8 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {content.map((c, i) =>
          isVehicle(c) ? (
            <VehicleCard
              {...c}
              key={c.vehicleId + '-' + i}
              location={location}
              isFirstImagePrioritized={i < 4}
            />
          ) : (
            <ExperienceCard
              experience={c}
              key={c.id + '-' + i}
              isFirstImagePrioritized={i < 4}
            />
          )
        )}
      </div>
      {isThereMorePage ? (
        <BButton className="mx-auto mt-6 block" onClick={onPageChange}>
          {t('seeMore')}
        </BButton>
      ) : null}
    </>
  );
};

export default VehicleList;
